import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
    providedIn: 'root'
})
export class MemberMutationGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        const userInfo = this.auth.getCurrentUserInfo();
        if (!this.roleService.isMember(userInfo?.role)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(userInfo?.role)]);
        return false;
    }
}
